var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{attrs:{"row-key":"username","data":_vm.reportData,"columns":_vm.tableColumns,"sortable":_vm.sortable,"loading":_vm.pending},scopedSlots:_vm._u([{key:"score",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.getScore(row))+" ")]}},{key:"feedback",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.messages.join("\n"))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }